import { render, staticRenderFns } from "./PasswordValidationText.vue?vue&type=template&id=0efe8aa9"
import script from "./PasswordValidationText.vue?vue&type=script&lang=js"
export * from "./PasswordValidationText.vue?vue&type=script&lang=js"
import style0 from "./PasswordValidationText.vue?vue&type=style&index=0&id=0efe8aa9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports